export default time => {
  const hour = Math.floor(time);
  const min = Math.round((time - hour) * 60);

  const isPM = hour >= 12;

  const hourIn12Hours = hour >= 13 ? hour - 12 : hour;

  const hourText = hourIn12Hours < 10 ? `0${hourIn12Hours}` : hourIn12Hours;
  const minText = min < 10 ? `0${min}` : min;

  return `${hourText}:${minText} ${isPM ? "PM" : "AM"}`;
};
